import { Trans } from '@lingui/macro'
import { ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import PositionList from 'components/PositionList'
import Row, { RowBetween } from 'components/Row'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useV3Positions } from 'hooks/useV3Positions'
import { useContext, useMemo } from 'react'
import { Inbox, Plus } from 'react-feather'
import { useWalletModalToggle } from 'state/application/hooks'
import styled, { ThemeContext } from 'styled-components/macro'
import { HideSmall, ThemedText } from 'theme'
import { PositionDetails } from 'types/position'

// import CTACards from './CTACards'
import { LoadingRows } from '../Pool/styleds'

const PageWrapper = styled(AutoColumn)`
  max-width: 870px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 800px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 500px;
  `};
`
const TitleRow = styled(RowBetween)`
  color: ${({ theme }) => theme.text2};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  `};
`

const NoLiquidity = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  max-width: 300px;
  min-height: 25vh;
`

export const MainContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.bg0};
  padding: 8px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
`

function PositionsLoadingPlaceholder() {
  return (
    <LoadingRows>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </LoadingRows>
  )
}

export default function AllPools() {
  const { account, chainId } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()

  const theme = useContext(ThemeContext)
  const { positions, loading: positionsLoading } = useV3Positions(account)
  const [openPositions, closedPositions] = positions?.reduce<[PositionDetails[], PositionDetails[]]>(
    (acc, p) => {
      acc[p.liquidity?.isZero() ? 1 : 0].push(p)
      return acc
    },
    [[], []]
  ) ?? [[], []]

  const filteredPositions = useMemo(() => {
    return openPositions
  }, [openPositions])
  const showConnectAWallet = Boolean(!account)

  return (
    <>
      {chainId !== 1 ? (
        <PageWrapper>
          {/* <ContractWarningBanner /> */}
          <AutoColumn gap="lg" justify="center">
            <AutoColumn gap="lg" style={{ width: '100%' }}>
              <TitleRow style={{ marginTop: '1rem', justifyContent: 'space-between' }} padding={'0'}>
                <Row style={{ width: 'max-content', display: 'flex', gap: '16px' }}>
                  <ThemedText.Body fontSize={'20px'}>
                    <Trans>Positions</Trans>
                  </ThemedText.Body>

                  {/* <ButtonLight style={{ width: '170px', padding: '8px 16px' }} onClick={handleOpenWhiteListModal}>
                    {' '}
                    <Trans>Eligible Tokens &darr;</Trans>
                  </ButtonLight> */}
                </Row>

                <ButtonPrimary
                  style={{
                    height: '24px',
                  }}
                  width={'max-content'}
                  as={'a'}
                  href="/#/add/"
                >
                  <Plus size={14} strokeWidth={2} />
                  <Trans>New Position</Trans>
                </ButtonPrimary>
              </TitleRow>

              <MainContentWrapper>
                {positionsLoading ? (
                  <PositionsLoadingPlaceholder />
                ) : filteredPositions && closedPositions && filteredPositions.length > 0 ? (
                  <PositionList positions={filteredPositions} redirectUrl="/pool/" />
                ) : (
                  <NoLiquidity>
                    <ThemedText.Body color={theme.text3} textAlign="center">
                      <Inbox size={48} strokeWidth={1} style={{ marginBottom: '.5rem' }} />
                      <div>
                        <Trans>Your active V3 liquidity positions will appear here.</Trans>
                      </div>
                    </ThemedText.Body>
                    {showConnectAWallet && (
                      <ButtonPrimary style={{ marginTop: '2em', padding: '8px 16px' }} onClick={toggleWalletModal}>
                        <Trans>Connect a wallet</Trans>
                      </ButtonPrimary>
                    )}
                  </NoLiquidity>
                )}
              </MainContentWrapper>
              <HideSmall>{/* <CTACards /> */}</HideSmall>
            </AutoColumn>
          </AutoColumn>
        </PageWrapper>
      ) : (
        <PageWrapper>
          <AutoColumn gap="lg" justify="center" style={{ marginBottom: '2rem' }}>
            <MainContentWrapper>
              <ThemedText.MediumHeader>
                We are currently live on Base and Optimism chain, and gearing up for our upcoming mainnet launch. Stay
                tuned ...
              </ThemedText.MediumHeader>
            </MainContentWrapper>
          </AutoColumn>
        </PageWrapper>
      )}
    </>
  )
}
